import { FeaturedCities } from 'ha/constants/FeaturedCities';
import { City } from '@ha/api/v2/types';
import { FeaturedLink } from '../components/FeaturedLinks/FeaturedLinks';

export const filterHiddenCities = (cities: City[]): City[] => {
  return cities.filter(item => !FeaturedCities[item.cityCanonical]?.isHidden);
};

export const filterApartments = (cities: City[]): City[] => {
  return cities.filter(
    item => FeaturedCities[item.cityCanonical]?.hasAppartmentLink,
  );
};

export const filterPrivateRooms = (cities: City[]): City[] => {
  return cities.filter(item => FeaturedCities[item.cityCanonical]?.hasRoomLink);
};

export const citiesToFeaturedLinks = (cities: City[]): FeaturedLink[] => {
  return cities.map(({ cityName, countryName, searchUrl }) => ({
    url: searchUrl,
    title: `${cityName}, ${countryName}`,
    textContent: [`${cityName}`, `, ${countryName}`],
  }));
};
